import React, { useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
const SchoolCabinet = () => { 
 
  return (
    <>
      <Header />
      <div className="innerslide Admissionbg">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>School Cabinet</li>
        </ul>
      </div>
      <div className="innersec cabinet">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
                
              <h1>School Cabinet</h1> 
            </div>
            <div className="topperssec">
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/KartikTiwari25.jpeg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                   Kartik Tiwari  <span>Head Boy </span>
                  </p>
                  <p> X Moon </p>
                </div>
              </div>
              <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/AnshikaVerma25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Anshika Verma     <span> Head Girl </span> </p> <p> X Moon  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/AnshPatel25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername"> Ansh Patel   <span> Vice Head Boy </span> </p> <p> IX Sun  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/GauriGautam25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Gauri Gautam   <span> Vice Head Girl  </span> </p> <p>  IX Moon  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/AbhinavSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Abhinav Singh  <span> Discipline Captain Boy    </span> </p> <p>  X Star </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/SatakshiSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Satakshi Singh   <span>  Discipline Captain Girl</span> </p> <p> X Star  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/ShashankPandey25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Shashank Pandey  <span> Discipline Vice Captain Boy </span> </p> <p> IX Sun  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/SandhyaRajak25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername"> Sandhya Rajak    <span> Discipline Vice Captain Girl </span> </p> <p> IX Star  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/SushantSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Sushant Singh  <span>Sports Captain Boy  </span> </p> <p> X Sun    </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/AnushkaPatel25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Anushka Patel <span> Sport Captain Girl  </span> </p> <p>  X Star  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/IshwarShrivastav25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Ishwar Shrivastav <span>  Sports Vice Captain Boy </span> </p> <p> IX Star   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/SaraswatiJaiswal25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Saraswati Jaiswal    <span> Sports Vice Captain Girl </span> </p> <p> IX Star  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/GyanPrakashPatel25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Gyan Prakash Patel   <span> Literary Captain Boy  </span> </p> <p>  X Moon  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/StutiPandey25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Stuti Pandey  <span>  Literary Captain Girl </span> </p> <p>   X Moon </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/AnkitPandey25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Ankit Pandey    <span> Cultural Captain Boy </span> </p> <p> IX Star   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/AnushkaJaiswal25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Anushka Jaiswal    <span> Cultural Captain Girl </span> </p> <p> X Sun</p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/AakashTiwari25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">    Aakash Tiwari  <span> Band Captain Boy  </span> </p> <p>IX Star   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/SanskritiShukla25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Sanskriti Shukla   <span>Band Captain Girl  </span> </p> <p>  IX Sun </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/SatyamSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Satyam Singh   <span> Band Vice Captain Boy </span> </p> <p> IX Sun  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/KajalRajak25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Kajal Rajak    <span> Band Vice Captain </span> </p> <p>IX Star   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/GauravSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Gaurav Singh   <span> Gandhi House Captain  </span> </p> <p>  X Moon </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/SakshiPandey25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Sakshi Pandey     <span> Gandhi House Captain Girl </span> </p> <p> X Sun  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/AnmolTripathi25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">    Anmol Tripathi <span>  Gandhi House Vice Captain  </span> </p> <p>  IX Sun </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/PihuTiwari25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Pihu Tiwari   <span>Gandhi House Vice Captain Girl  </span> </p> <p>  IX Star  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/AbyudhayaSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Abyudhaya Singh    <span> Alphonsa House Captain </span> </p> <p>  X Star </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/ManyaPandey25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Manya Pandey     <span> Alphonsa House Captain Girl </span> </p> <p>X Sun   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/ShreyashSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Shreyash Singh   <span>Aophonsa House Vice Captain  </span> </p> <p>  IX Sun   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/SakshiSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Sakshi Singh  <span>  Alphonsa House Vice Captain Girl </span> </p> <p> IX Star   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/AyanshPandey25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Ayansh Pandey    <span>Kalam House Captain  </span> </p> <p> X Moon  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/ShreyashiSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Shreyashi Singh   <span>Kalam House Captain Girl  </span> </p> <p>   X Sun </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/RudraSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Rudra Singh  <span>  Kalam House Vice Captain </span> </p> <p>  IX Star </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/kritikaSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   kritika Singh   <span> Kalam House Vice Captain Girl </span> </p> <p>  IX Sun </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/ShantanuSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Shantanu Singh  <span> Mother Teresa  House Captain  </span> </p> <p>  X Moon  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/TanviVishwakarma25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">    Tanvi Vishwakarma <span> Mother Teresa House Captain  </span> </p> <p>X Star    </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/PrasannShukla25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Prasann Shukla   <span>Mother Teresa House Vice Capatain    </span> </p> <p>IX Moon   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/StutiMishra25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Stuti Mishra    <span> Mother Teresa House Vice Captain Girl </span> </p> <p>  IX Sun </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/KanishkTiwari25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Kanishk Tiwari     <span> Science Club Captain </span> </p> <p> X Sun  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/VrindaMishra25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Vrinda Mishra   <span> Science Club Captain Girl </span> </p> <p>   X Star </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/Rudra-PratapMishra25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Rudra Pratap Mishra   <span> Maths Club Captain  </span> </p> <p> X Moon  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/JahanviGupta25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Jahanvi Gupta   <span>Maths Club Captain Girl  </span> </p> <p>IX Sun    </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/Pratham-Chaturvedi25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername"> Pratham Chaturvedi<span>Cyber Club Captain  </span> </p> <p>  IX Moon </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/Prinshika-Singh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Prinshika Singh   <span>   Cyber Club Captain Girl</span> </p> <p>X Moon   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/Anurag-Sharma25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Anurag Sharma   <span>  Social Science Club Captain </span> </p> <p> IX Moon  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/Anushri-Srivastava25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Anushri Srivastava <span>  Social Science Club Girl </span> </p> <p> IX Star   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/UjjwalSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Ujjwal Singh  <span>  Language Club Captain  </span> </p> <p>  IX Moon </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/Akriti-Singh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Akriti Singh   <span>  Language Club Captain girl </span> </p> <p>IX Moon   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/ShubhGautam25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Shubh Gautam    <span>Social Service Club Captain  </span> </p> <p>  X Sun </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/PoornimaSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Poornima Singh   <span>Social Sevice Club Captain Girl  </span> </p> <p> IX   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/Shivam-Jaiswal25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Shivam Jaiswal    <span> Art Club Captain </span> </p> <p> X Moon   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/Sagun-Jaiswal25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername"> Sagun Jaiswal   <span> Art Club Captain Girl </span> </p> <p> IX Star   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/Ansh-Tiwari25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Ansh Tiwari   <span> Eco Club Captain </span> </p> <p>IX Moon   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/Bhavya-Tiwari25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Bhavya Tiwari  <span>  Eco Club Captain Club  </span> </p> <p>IX Star   </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/PragyanSingh25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">   Pragyan Singh    <span>Swacchata Club Captain   </span> </p> <p> X Star  </p>
             </div> 
            </div>
            <div className="topperdiv"> 
              <div className="topperdivimg">
               <LazyLoad offset={10} placeholder={ <img src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg" alt="Loading..." className="img-fluid" /> }> 
               <img src="https://webapi.entab.info/api/image/GHSS/public/Images/PavaniChaturvedi25.jpeg" className="img-fluid" alt="Placeholder" />
              </LazyLoad> 
            </div>
             <div className="topperdivdesc">
              <p className="toppername">  Pavani Chaturvedi  <span>  Swacchata Club Captain Girl  </span> </p> <p>IX Moon   </p>
             </div> 
            </div>
            
              </div>
           { /*  <div className="topperssec">
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Ashim_Ranjan.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Ashim Ranjan Mishra <span>Head Boy </span>
                  </p>
                  <p> X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Anjali.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Anjali Mishra <span>Head Girl </span>
                  </p>
                  <p> X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Ved-Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Ved Singh Parihar <span>Vice Head Boy </span>
                  </p>
                  <p> IX Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Tanvi.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Tanvi Vishwakarma <span>Vice Head Girl </span>
                  </p>
                  <p> IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Shubham-Dubey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shubham Dubey <span>Discipline Captain Boy</span>
                  </p>
                  <p> X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Mansi-Sahu.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Mansi Sahu <span>Discipline Captain Girl</span>
                  </p>
                  <p>X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Kanishk-Tiwari.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Kanishk Tiwari <span>Discipline Vice Captain Boy</span>
                  </p>
                  <p>IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Anshika-Verma.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Anshika Verma <span>Discipline Vice Captain Girl</span>
                  </p>
                  <p>IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Vansh_Basantani.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Vansh Basantani <span>Sports Captain Boy</span>
                  </p>
                  <p>X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Rashu_Mishra.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Rashu Mishra <span>Sports Captain Girl</span>
                  </p>
                  <p>X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Abhinav_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Abhinav Singh<span>Sports Vice Captain Boy</span>
                  </p>
                  <p>IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Niyati_Pandey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Niyati Pandey <span>Sports Vice Captain Girl</span>
                  </p>
                  <p>IX Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Aarush_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Aarush Singh <span>literary Captain Boy</span>
                  </p>
                  <p>X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Ritika_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Ritika Singh <span>Literary Captain Girl</span>
                  </p>
                  <p>X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Gyan_Prakash.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Gyan Prakash Patel<span>Literary Vice Captain Boy</span>
                  </p>
                  <p>IX Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Vlrinda_Mishra.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Vlrinda Mishra <span>Literary Vice Captain Girl</span>
                  </p>
                  <p>IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Adarsh_Mishra.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Adarsh Mishra<span>Cultural Captain Boy</span>
                  </p>
                  <p>X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Aradhya_Pandey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Aradhya Pandey <span>Cultural Captain Girl</span>
                  </p>
                  <p>X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Rudra_Pratap.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Rudra Pratap Mishra <span>Cultural Vice Captain Boy</span>
                  </p>
                  <p>IX Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Anushka_Jaiswal.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Anushka Jaiswal <span>Cultural Vice Captain Girl</span>
                  </p>
                  <p>IX Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Anmol_Tripathi.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Anmol Tripathi <span>Band Captain Boy </span>
                  </p>
                  <p>VIII Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Pihu_Tiwari.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Pihu Tiwari <span>Band Captain Girl</span>
                  </p>
                  <p>VIII Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Ankit_Pandey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Ankit Pandey<span>Band Vice Captain Boy</span>
                  </p>
                  <p> VIII Star </p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Anvesha_Pandey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Anvesha Pandey <span>Band Vice Captain Girl</span>
                  </p>
                  <p>VIII Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Pratyush_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Pratyush Singh <span>Gandhi House Captain Boy</span>
                  </p>
                  <p>X Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Anushka_Mishra.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Anushka Mishra <span>Gandhi House Captain Girl</span>
                  </p>
                  <p>X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Pragyan_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Pragyan Singh <span>Gandhi House Vice Captain</span>
                  </p>
                  <p>IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Sakshi_Pandey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Sakshi Pandey <span>Gandhi House Vice Captain Girl</span>
                  </p>
                  <p>IX Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Prateek_Tripathi.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Prateek Tripathi <span>Alphonsa House Captain</span>
                  </p>
                  <p> X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Swara_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Swara Singh <span>Alphonsa House Captain Girl</span>
                  </p>
                  <p>X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Aayansh_Pandey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Aayansh Pandey <span> Alphonsa House Vice Captain</span>
                  </p>
                  <p>IX Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Shreyashi_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shreyashi Singh{" "}
                    <span>Alphonsa House Vice Captain Girl</span>
                  </p>
                  <p>IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Naitik_Tiwari.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Naitik Tiwari <span>Kallam House Captain</span>
                  </p>
                  <p>X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Samiksha_Pandey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Samiksha Pandey <span>Kalam House Captain Girl</span>
                  </p>
                  <p>X Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Shantanu_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shantanu Singh<span>Kalam House Vice Captain</span>
                  </p>
                  <p>IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Manya_Pandey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Manya Pandey <span>Kalam House Vice Captain Girl</span>
                  </p>
                  <p>IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Devanshik_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Devanshik Singh <span>Mother Teresa House Captain</span>
                  </p>
                  <p>X Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Ichchha_Mishra.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Ichchha Mishra <span>Mother Teresa House Captain Girl</span>
                  </p>
                  <p>X Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Satakshi_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Satakshi Singh <span>Mother Teresa House vice Captain</span>
                  </p>
                  <p>IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Swapdeep_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Swapdeep Singh <span>Science Club Captain</span>
                  </p>
                  <p>X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Shalini_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Shalini Singh <span>Science Club Captain Girl</span>
                  </p>
                  <p>X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Aaradhya_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Aaradhya Singh <span>Maths Club Captain</span>
                  </p>
                  <p>X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Shrishty_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Shrishty Singh <span>Maths Club Captain Girl</span>
                  </p>
                  <p>X Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Krishna_Chattani.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Krishna Chattani <span>Cyber Club Captain</span>
                  </p>
                  <p>X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Vaishnavi_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Vaishnavi Singh <span>Cyber Club Captain Girl</span>
                  </p>
                  <p>X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Abhiyuday_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Abhiyuday Singh <span>Social Science Club Captain</span>
                  </p>
                  <p>IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Stuti_Pandey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Stuti Pandey <span>Social Science Club Captain Girl</span>
                  </p>
                  <p>IX Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Ujjwal_Pandey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    Ujjwal Pandey <span>Lanuage Club Captain</span>
                  </p>
                  <p>X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Sanskriti_Chaturvedi.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Sanskriti Chaturvedi <span>Language Club Captain Girl</span>
                  </p>
                  <p>X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Aditya_Vardhan.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Aditya Vardhan Singh{" "}
                    <span>Social Service Club Captain</span>
                  </p>
                  <p>IX Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Pranjali_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Pranjali Singh <span>Social Service Club Captain Girl</span>
                  </p>
                  <p>X Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Ankur_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Ankur Singh Somvanshi <span>Art Club Captain</span>
                  </p>
                  <p>X Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Anshika_Pandey.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Anshika Pandey <span>Art Club Captain Girl</span>
                  </p>
                  <p>X Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Vivedk_Gautam.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Vivedk Gautam <span>Eco Club Captain</span>
                  </p>
                  <p>X Sun</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Rubi_Shukla.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Rubi Shukla <span>Eco Club Captain Girl</span>
                  </p>
                  <p>X Star</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Gaurav_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Gaurav Singh <span>Swacchata Club Captain</span>
                  </p>
                  <p>IX Moon</p>
                </div>
              </div>
              <div className="topperdiv">
                <div className="topperdivimg">
                  <LazyLoad
                    offset={10}
                    placeholder={
                      <img
                        src="https://webapi.entab.info/api/image/GHSS/public/Images/sld3.jpg"
                        alt="Loading..."
                        className="img-fluid"
                      />
                    }>
                    <img
                      src="https://webapi.entab.info/api/image/GHSS/public/Images/Nitya_Singh.jpg"
                      className="img-fluid"
                      alt="Placeholder"
                    />
                  </LazyLoad>
                </div>
                <div className="topperdivdesc">
                  <p className="toppername">
                    {" "}
                    Nitya Singh <span>Swacchata Club Captain Girl</span>
                  </p>
                  <p>IX Star</p>
                </div>
              </div>
                  </div> */ }
                  
              
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default SchoolCabinet;
